"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var LaddaConfigArgs = (function () {
    function LaddaConfigArgs() {
    }
    return LaddaConfigArgs;
}());
exports.LaddaConfigArgs = LaddaConfigArgs;
exports.configAttributes = {
    "data-style": "style",
    "data-spinner-size": "spinnerSize",
    "data-spinner-color": "spinnerColor",
    "data-spinner-lines": "spinnerLines",
};
var LaddaConfig = (function () {
    function LaddaConfig(config) {
        if (config === void 0) { config = {}; }
        Object.assign(this, config);
    }
    return LaddaConfig;
}());
LaddaConfig.decorators = [
    { type: core_1.Injectable },
];
/** @nocollapse */
LaddaConfig.ctorParameters = function () { return [
    { type: LaddaConfigArgs, },
]; };
exports.LaddaConfig = LaddaConfig;
//# sourceMappingURL=ladda-config.js.map


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/angular2-ladda/module/ladda-config.js
// module id = ../../../../angular2-ladda/module/ladda-config.js
// module chunks = 8